import React from "react"
import { Panel } from "primereact/panel"
import { useHistory, useParams } from "react-router-dom";
import { WalletTransactionDto, WalletService, CreditDto, TopUpEligibleResultDto } from "../../domain";
import { tawreedTranslationService } from "../../../../common/translations";
import { TawreedForm, TawreedFormField, TawreedFormMode, TawreedFormSubmitAction, TawreedFormSubmitCallback, TawreedFormSubmitProps, TawreedInputNumber, TawreedInputText, TawreedInputTextarea, TawreedMenuDropdown } from "../../../../common";
import { TopupPartnerAutoCompleteComponent } from "./autocomplete";
import { TawreedAction, TawreedActionName } from "../../../../common/actions";
import { PrimeIcons } from "primereact/api";
import { toastService } from "../../../notifications/domain";
import { ConfirmDialog } from "./confirm-dialog";
import { OtpDialog } from "./otp-dialog";
import { Routes } from "../../../../router";
import { GlobalContext } from "../../../../context";


export const WalletTransactionForm: React.FC = () => {

    const service: WalletService = React.useMemo(() => new WalletService(), []);

    const [loading, setLoading] = React.useState<boolean>(false);
    const [mode, setMode] = React.useState<TawreedFormMode>('Create');
    const [data, setData] = React.useState<CreditDto>();
    const [confirmDialog, setConfirmDialog] = React.useState<{
        visible: boolean,
        data?: TopUpEligibleResultDto
    }>({
        visible: false,
        data: undefined
    });
    const [onboard, setOnboard] = React.useState(false);
    const [otpDialog, setOtpDialog] = React.useState(false);
    const [actions, setActions] = React.useState(Array<TawreedAction>);

    const { auth: { user } } = React.useContext(GlobalContext);
    const history = useHistory();

    React.useEffect(() =>{
        if(onboard)
        {
            setActions([
            new TawreedAction(TawreedActionName.OnBoard, 'stateless', 'lbl_onboard', PrimeIcons.SAVE, onboardAction, 'p-button-text')
        ]);
    }
        else{
            setActions([]);
        }
    },[onboard]);

    const onCreateOrSave = (data: CreditDto, cb: TawreedFormSubmitCallback<CreditDto>): Promise<void> => {
        if(!data)
        {
            return new Promise<void>((resolve, reject) => {
                reject();
            });
        }
        if(!data.topUpPartner?.topUpThroughUs)
        {
            window.open(data.topUpPartner?.instructionUrl);
            return new Promise<void>((resolve, reject) => {
                reject();
            });
        }
        else{
            setLoading(true);
        return service.checkEligible(data)
            .then(res => {
                setLoading(false);
                if (!res.eligible) {
                    if (!res.showOnBoard)
                    {
                        toastService.show({ detail: res.message, severity: 'error' });
                    }
                    else {
                        toastService.show({ detail: res.message, severity: 'error' });
                        setOnboard(true);
                    }
                }
                else {
                    setConfirmDialog({
                        visible: true,
                        data: res
                    });
                }
                // setPost(undefined);
                // cb(data);
            })
            .catch(err => {
                
                // setOnboard(true);
                setLoading(false);
                // setConfirmDialog({
                //     visible: true,
                //     data: {
                //         amount: data.amount!,
                //         cashback: 1,
                //         eligible: true,
                //         fees:1,
                //         feesTax:2,
                //         message:"$4",
                //         showOnBoard: false,
                //         total: 22,
                    
                //     }}),
                cb(err);
            });
        }
    }
    const topupRequest = (): Promise<boolean> => {
        setLoading(true);
        console.log(data);
                return service.requestTopup(data!)
                    .then((res) => {
                        setLoading(false);
                        return true;
                        //history.push(Routes.SalesCartsSearch);
                    })
                    .catch((e) => {
                        setLoading(false);
                        return true;
                    });
    }

    const confirmTopup = (): Promise<void> => {
        setLoading(true);
                return service.confirmTopup(data!)
                    .then((res) => {
                        setLoading(false);
                        history.push(Routes.TopupAddCredit);
                        return new Promise<void>((resolve, reject) => {
                            resolve();
                        });
                    })
                    .catch((e) => {
                        setLoading(false);
                        return new Promise<void>((resolve, reject) => {
                            reject();
                        });
                    });
    }
    const onboardAction = (): Promise<void> => {
        return new Promise((resolve) => {
            history.push(Routes.TopupOnboardNew.replace(":id", data?.topUpPartner?.topUpPartnerId ?
                data?.topUpPartner?.topUpPartnerId.toString() : ""));
            resolve();
        })
    };
    const onSubmit: TawreedFormSubmitProps<CreditDto> = {
        showButton: true,
        resetOnSubmit: false,
        onSubmit: new TawreedFormSubmitAction<CreditDto>(TawreedActionName.AddCredit, 'lbl_add', PrimeIcons.SAVE, onCreateOrSave, 'p-button-text mr-1')
    };

    return (
        <React.Fragment>

            <TawreedForm title="lbl_topup"
                dataKey="walletTransactionId" data={data}
                submit={onSubmit}
                loading={loading} mode={mode} actions={actions}
                useBack=".." className="grid form-grid">
                <Panel header={tawreedTranslationService.translate('lbl_general_information')} className="col-12">
                    <div className="grid">
                        <TawreedFormField name="topUpPartner" title="lbl_finance_documents_partner" className="field col-12 md:col-6">
                            {<TopupPartnerAutoCompleteComponent
                                autoCompleteName="topUpPartner"
                                autoCompleteField="partnerName"
                                autoCompleteRules={{ required: "msg_field_is_required" }}
                                autoCompleteValue={data?.topUpPartner}
                                autoCompleteOnSelect={(e)=>setData({...data, topUpPartner: e.value})}
                                autoCompleteRender="form" />}
                        </TawreedFormField>
                        <TawreedFormField name="amount" className="field col-12 md:col-6" title="lbl_wallet_transaction_amount">
                            <TawreedInputNumber mode="decimal" name="amount" render="form"
                            onChange={(e)=>setData({...data, amount: e.value?? 0})} rules={{ required: 'msg_field_is_required' }} />
                        </TawreedFormField>

                    </div>
                </Panel>
            </TawreedForm>
            <ConfirmDialog
                hide={() => setConfirmDialog({ ...ConfirmDialog, visible: false })}
                topUpEligibleResult={confirmDialog.data}
                visible={confirmDialog.visible}
                accept={() => {
                    setLoading(true);
                    topupRequest().then((res)=>{
                        setLoading(false);
                        if(res)
                            setOtpDialog(true);
                    }).catch(()=> setLoading(false))
                }}
            />
            <OtpDialog
                visible={otpDialog}
                changeOtp={(value) => {
                    setData({
                        ...data,
                        otp: value
                    });
                }}
                accept={() => {

                    setOtpDialog(false);
                    confirmTopup();
                    
                }}
                otpValue={data?.otp}

                hide={() => { setOtpDialog(false) }}
            />
        </React.Fragment>
    )
}
